import { lazy } from 'react';
import { PrivateRoute } from '../../components/PrivateRoute/PrivateRoute';
import { baseUrls } from '../../constants/urls';
const AccountChangeRequests = lazy(() => import('./pages/AccountChangeRequests/AccountChangeRequests'));
const AccountChangeRequest = lazy(() => import('./pages/AccountChangeRequest/AccountChangeRequest'));

const AcrRoutes = [
  <PrivateRoute path={baseUrls.accountChangeRequests} exact={true} permissions="accountChangeRequestEnabled" key="accountChangeRequests">
    <AccountChangeRequests />
  </PrivateRoute>,
  <PrivateRoute path={baseUrls.accountChangeRequest} exact={true} permissions="accountChangeRequestEnabled" key="accountChangeRequest">
    <AccountChangeRequest />
  </PrivateRoute>
];

export default AcrRoutes;
